export default "__VITE_ASSET__d3204127__"